export class Sms {
    public to: string[] = [];

    public content: string = null;

    public static from(other: any) {
        if (!!other) {
            const instance = new Sms();

            instance.to = [...other.to];
            instance.content = other.content;

            return instance;
        } else {
            return null;
        }
    }
}
